import PhotoSwipeLightbox from "photoswipe/lightbox"

document.addEventListener("DOMContentLoaded", () => {
  initGalleries()
})

function initGalleries() {
  document
    .querySelectorAll(".photoswipe-container")
    .forEach(async (gallery) => {
      await Promise.all(
        [...gallery.querySelectorAll(".photoswipe-image")].map(
          (imageHolder) => {
            return new Promise((resolve) => {
              const img = imageHolder.querySelector("img")

              const refreshPhotoswipeSize = () => {
                imageHolder.setAttribute("data-pswp-width", img.naturalWidth)
                imageHolder.setAttribute("data-pswp-height", img.naturalHeight)
                resolve()
              }

              if (img.complete) {
                return refreshPhotoswipeSize()
              }

              img.onload = () => {
                refreshPhotoswipeSize()
              }

              img.onerror = () => resolve()
            })
          },
        ),
      )

      const lightbox = new PhotoSwipeLightbox({
        gallery: gallery,
        children: ".photoswipe-image",
        initialZoomLevel: "fit",
        secondaryZoomLevel: "fit",
        showHideAnimationType: "none",
        pswpModule: () => import("photoswipe"),
      })

      lightbox.on("uiRegister", () => {
        lightbox.pswp.ui.registerElement({
          name: "custom-caption",
          order: 9,
          isButton: false,
          appendTo: "root",
          onInit: (captionElement, pswp) => {
            pswp.on("change", () => {
              const { element } = pswp.currSlide.data

              if (!element) {
                return
              }

              const imageElement = element.querySelector("img")

              if (!imageElement) {
                return
              }

              const caption =
                imageElement.getAttribute("title") ||
                imageElement.getAttribute("alt")

              if (!caption) {
                captionElement.style.display = "none"

                return
              }

              captionElement.style.display = "block"
              captionElement.innerHTML = caption
            })
          },
        })
      })

      lightbox.init()
    })
}
